<template>
  <div id="about">
    <v-sheet id="main" class="overflow-y-auto">
      <v-layout class="pt-lg-16 pt-sm-10 pa-12 column">
        <!-- <v-row>
          <v-col cols="12">
            <v-card class="rounded-xl pa-6 on-hover">
              <h3>End User</h3>
              <v-row>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/n0vc3fwRsjI"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/IpIob2vzfLU"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/JMFFOF-e6EU"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/5sucZD8hQ8M"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/WswAmY73SLE"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <v-card class="rounded-xl pa-6 on-hover">
              <h3>Provider</h3>
              <v-row>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/BhqjRRDsJUk"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/IL7v5PPpmlw"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/JxkW-MTpziI"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/pmPmtBwlCug"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/LzzYyOXVIJ0"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/OY2dBehX2Sc"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
                <v-col cols="4">
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/SREKNUV8brA"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'Tutorials',
};
</script>
